import { render, staticRenderFns } from "./MarriageVisa.vue?vue&type=template&id=3d1f29f6&"
import script from "./MarriageVisa.vue?vue&type=script&lang=js&"
export * from "./MarriageVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports